// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mobileCutomPaddingNotif .b-dropdown-text[data-v-7c1005b6]{padding:0!important}.v-app-bar.v-app-bar--is-scrolled[data-v-7c1005b6] .v-toolbar__image{opacity:1}.v-app-bar[data-v-7c1005b6] .v-toolbar__image{-webkit-transition:opacity .15s ease-in;transition:opacity .15s ease-in;opacity:0}.app-bar-img[data-v-7c1005b6] .v-responsive__content{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);
// Exports
module.exports = exports;
